import styled from 'styled-components';

import { Link } from 'react-router-dom';

import { CallToAction } from 'packages/smart-home-support/styling/styles';

export default styled(Link)`
  ${CallToAction}
  color: ${(props) => props.theme.colors.primaryAccentOnWhite};
  box-shadow: none;
  font-size: 16px;
  background: #fff;
  padding: 13px 30px;
  border: 2px solid ${(props) => props.theme.colors.primaryAccentOnWhite};
  margin-right: -65px;
  text-transform: ${(props) => props.theme.styles.callToActionTextTransform};
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/HeaderCallToAction.tsx